// start here for web `<Type />`
import Type from './type/Type';
export * from './type/Type';
export default Type;